import React from 'react';
import heroCloud from '../assets/images/hero/hero-cloud.png';
import GooglePlayLogo, { PLAY_STORE_URL } from './GooglePlayLogo';

interface AppCtaProps {
  eyebrow?: string;
  title?: string;
  text?: string;
}

/** Full-width coral "download the app" band shared by the marketing pages. */
const AppCta: React.FC<AppCtaProps> = ({
  eyebrow = 'Get started today',
  title = 'Ready to Simplify Your Property Management?',
  text = 'Start for free — no credit card required. Try Guest Mode instantly or sign in with Google or email to sync your data across devices.'
}) => (
  <section className="cta-v2">
    <span className="cta-v2-circle cta-v2-circle-1" aria-hidden="true"></span>
    <span className="cta-v2-circle cta-v2-circle-2" aria-hidden="true"></span>
    <img className="cta-v2-cloud" src={heroCloud} alt="" aria-hidden="true" />

    <div className="container cta-v2-inner">
      <div className="cta-v2-content">
        <span className="cta-v2-eyebrow">{eyebrow}</span>
        <h2 className="cta-v2-title">{title}</h2>
        <p className="cta-v2-text">{text}</p>
        <ul className="cta-v2-points">
          <li><i className="fas fa-check" aria-hidden="true"></i>Free to start</li>
          <li><i className="fas fa-check" aria-hidden="true"></i>No credit card</li>
          <li><i className="fas fa-check" aria-hidden="true"></i>Instant Guest Mode</li>
        </ul>
      </div>

      <div className="cta-v2-action">
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hero-btn hero-btn-play cta-v2-btn"
        >
          <GooglePlayLogo className="hero-btn-play-logo" />
          Get Started Free
        </a>
        <span className="cta-v2-note">Available on Android · Google Play</span>
      </div>
    </div>
  </section>
);

export default AppCta;
